import React from 'react';
import { Accordion } from 'react-bootstrap';

const OracleConcepts = () => {
  return (
    <Accordion defaultActiveKey="0">
      <Accordion.Item eventKey="0">
        <Accordion.Header><b>Creating a Database</b></Accordion.Header>
        <Accordion.Body>
          <p>
            Oracle databases are typically created using Oracle Database Configuration Assistant (DBCA). However, you can also create a database manually using SQL commands.
          </p>
          <pre>
            {`CREATE DATABASE my_database
USER SYS IDENTIFIED BY sys_password
USER SYSTEM IDENTIFIED BY system_password
LOGFILE GROUP 1 ('/u01/app/oracle/oradata/my_database/redo01.log') SIZE 50M,
        GROUP 2 ('/u01/app/oracle/oradata/my_database/redo02.log') SIZE 50M
MAXLOGFILES 5
MAXLOGHISTORY 1
MAXDATAFILES 100
MAXINSTANCES 1
CHARACTER SET AL32UTF8
NATIONAL CHARACTER SET AL16UTF16
DATAFILE '/u01/app/oracle/oradata/my_database/system01.dbf' SIZE 325M REUSE
EXTENT MANAGEMENT LOCAL
SYSAUX DATAFILE '/u01/app/oracle/oradata/my_database/sysaux01.dbf' SIZE 325M REUSE
DEFAULT TABLESPACE users
DEFAULT TEMPORARY TABLESPACE temp TEMPFILE '/u01/app/oracle/oradata/my_database/temp01.dbf' SIZE 20M
UNDO TABLESPACE undotbs1 DATAFILE '/u01/app/oracle/oradata/my_database/undotbs01.dbf' SIZE 200M;`}
          </pre>
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="1">
        <Accordion.Header><b>Creating a Table</b></Accordion.Header>
        <Accordion.Body>
          <p>
            To create a table within a database, use the <code>CREATE TABLE</code> statement.
          </p>
          <pre>
            {`CREATE TABLE users (
  id NUMBER GENERATED BY DEFAULT AS IDENTITY,
  name VARCHAR2(100),
  email VARCHAR2(100),
  created_at TIMESTAMP DEFAULT CURRENT_TIMESTAMP,
  PRIMARY KEY (id)
);`}
          </pre>
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="2">
        <Accordion.Header><b>Inserting Data</b></Accordion.Header>
        <Accordion.Body>
          <p>
            To insert data into a table, use the <code>INSERT INTO</code> statement.
          </p>
          <pre>
            {`INSERT INTO users (name, email) VALUES ('John Doe', 'john.doe@example.com');`}
          </pre>
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="3">
        <Accordion.Header><b>Querying Data</b></Accordion.Header>
        <Accordion.Body>
          <p>
            To retrieve data from a table, use the <code>SELECT</code> statement.
          </p>
          <pre>
            {`SELECT * FROM users;`}
          </pre>
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="4">
        <Accordion.Header><b>Updating Data</b></Accordion.Header>
        <Accordion.Body>
          <p>
            To update existing data in a table, use the <code>UPDATE</code> statement.
          </p>
          <pre>
            {`UPDATE users SET email = 'new.email@example.com' WHERE name = 'John Doe';`}
          </pre>
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="5">
        <Accordion.Header><b>Deleting Data</b></Accordion.Header>
        <Accordion.Body>
          <p>
            To delete data from a table, use the <code>DELETE</code> statement.
          </p>
          <pre>
            {`DELETE FROM users WHERE name = 'John Doe';`}
          </pre>
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="6">
        <Accordion.Header><b>Joining Tables</b></Accordion.Header>
        <Accordion.Body>
          <p>
            To combine rows from two or more tables, use the <code>JOIN</code> statement.
          </p>
          <pre>
            {`SELECT users.name, orders.product_name
FROM users
JOIN orders ON users.id = orders.user_id;`}
          </pre>
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="7">
        <Accordion.Header><b>Creating an Index</b></Accordion.Header>
        <Accordion.Body>
          <p>
            To create an index on a table, use the <code>CREATE INDEX</code> statement.
          </p>
          <pre>
            {`CREATE INDEX idx_name ON users (name);`}
          </pre>
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="8">
        <Accordion.Header><b>Creating a View</b></Accordion.Header>
        <Accordion.Body>
          <p>
            To create a virtual table based on the result-set of a query, use the <code>CREATE VIEW</code> statement.
          </p>
          <pre>
            {`CREATE VIEW user_emails AS
SELECT name, email FROM users;`}
          </pre>
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="9">
        <Accordion.Header><b>Stored Procedures</b></Accordion.Header>
        <Accordion.Body>
          <p>
            To create a stored procedure, use the <code>CREATE PROCEDURE</code> statement.
          </p>
          <pre>
            {`CREATE OR REPLACE PROCEDURE GetUserEmail (user_id IN NUMBER, user_email OUT VARCHAR2) AS
BEGIN
  SELECT email INTO user_email FROM users WHERE id = user_id;
END GetUserEmail;`}
          </pre>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default OracleConcepts;
